import { Box, Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import type { TimelineItemResponseDTO as TimelineItem } from "web_myplann/Infrastructure/Api/Api";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { TimelineEntry } from "web_myplann/NotificationCenter/Components/TimelineEntry";
import { NOTIFICATION_CENTER_TABS } from "web_myplann/NotificationCenter/Constants/notificationCenterTabs";
import type { UpcomingGroup } from "web_myplann/NotificationCenter/Hooks/useGroupUpcomingItems";

interface TimelineGroupProps {
	group: UpcomingGroup;
	onItemClick: (item: TimelineItem) => void;
}

export const TimelineGroup: FC<TimelineGroupProps> = ({
	group,
	onItemClick,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	const muted = group.visualWeight === "muted";

	return (
		<Stack
			data-testid={`timeline-group-${group.bucketKey}`}
			sx={{
				opacity: muted ? 0.6 : 1,
				backgroundColor: theme.palette.grey[100],
			}}
		>
			<Typography
				fontSize={11}
				fontWeight={600}
				color={muted ? theme.palette.text.secondary : theme.palette.grey[600]}
				sx={{
					textTransform: "uppercase",
					letterSpacing: 0.5,
					px: 1.6,
					pt: 1.2,
					pb: 0.8,
				}}
			>
				{t(group.labelResource)}
			</Typography>
			<Box sx={{ mb: 1.2 }}>
				{group.items.map((item, index) => (
					<TimelineEntry
						key={item.id}
						item={item}
						tab={NOTIFICATION_CENTER_TABS.Upcoming}
						onClick={onItemClick}
						isLast={index === group.items.length - 1}
					/>
				))}
			</Box>
		</Stack>
	);
};
